import React from 'react';

const HowWeWork = () => {
  const steps = [
    {
      id: "01.",
      title: "Site Feasibility Study",
      desc: "Conducting detailed technical site assessments and energy load analysis for MNC facilities.",
      align: "left"
    },
    {
      id: "02.",
      title: "Infrastructure Construction",
      desc: "Managing full-scale civil and electrical building of high-performance charging hubs.",
      align: "right"
    },
    {
      id: "03.",
      title: "Electrical & Grid Connectivity",
      desc: "Establishing expert LT/HT network connections and professional commercial meter upgrades.",
      align: "left"
    },
    {
      id: "04.",
      title: "Site Commissioning",
      desc: "Performing final end-to-end testing and technical activation for immediate operations.",
      align: "right"
    }
  ];

  return (
    <section className="how-work bg-lightgreen py-10">
      <div className="container">
        <div className="how-work-inner">
          <div className="section-title text-center w-lg-50 w-md-75 m-auto mb-8">
            <h6 className="text-uppercase fw-medium mb-1 green1">How we work</h6>
            <h2 className="fw-bold mb-2">
              Professional <span className="green">EV Charging</span> Solution for You
            </h2>
            <p>To provide a professional overview for Denial Enterprise, here are the four core steps of your workflow as a trusted MNC vendor, along with concise descriptions for each.</p>
          </div>
          
          <div className="section-body position-relative">
            <div className="timeline position-relative z-2 text-center text-md-start">
              {steps.map((step, index) => (
                <div 
                  key={index} 
                  className={`timeline-row position-relative w-md-50 mb-4 ${step.align === 'right' ? 'ms-auto' : ''}`}
                >
                  <div className={`work-box-number text-center p-2 rounded-circle border border-3 border-lightgreen bg-green d-inline-block h-auto mb-2 position-absolute top-50 translate-middle ${step.align === 'right' ? 'start-0' : 'start-100'}`}>
                    <h4 className="text-white mb-0">{step.id}</h4>
                  </div>
                  
                  <div className={`work-info position-relative p-4 border-3 border border-white bg-lightgreen1 rounded2 ${step.align === 'right' ? 'ms-9' : 'me-9'}`}>
                    <h4 className="mb-3 fw-bold">{step.title}</h4>
                    <p className="mb-0 text-muted">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;